import { openConsentManager } from '../../scripts/consentManager';

const footerJsClass = 'js-footer';
const footerButtonJsClass = footerJsClass + '-button';

const footerButtonElement = document.querySelector('.' + footerButtonJsClass) as HTMLElement;

if (footerButtonElement) {
    footerButtonElement.addEventListener('click', () => {
        openConsentManager();
    });
}